import { environment } from "../../config";
import {
  iDataPlan,
  PostPlanFields,
  PutPlanFields,
} from "../../interfaces/SuperAdmin/Pages/iDataPlan";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL, VERSION } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

export const getAllPlans = (estado?: string, id_organizacion?: string) =>
  fetchData<iDataPlan[]>({
    method: "GET",
    url: `${baseApiBroker}/plan`,
    params: {
      ...(estado && { estado }),
      ...(id_organizacion && { id_organizacion }),
      version: VERSION,
    },
  });

export const getPlanById = (id: string) =>
  fetchData<iDataPlan>({
    method: "GET",
    url: `${baseApiBroker}/plan/${id}`,
  });

export const postPlan = (data: PostPlanFields) =>
  fetchData<iDataPlan>({
    method: "POST",
    url: `${baseApiBroker}/plan`,
    data,
  });

export const deletePlanById = (id: string) =>
  fetchData<{}>({
    method: "DELETE",
    url: `${baseApiBroker}/plan/${id}`,
  });

export const putPlanById = (id: string, data: PutPlanFields) =>
  fetchData<iDataPlan>({
    method: "PUT",
    url: `${baseApiBroker}/plan/${id}`,
    data,
  });
